import { __decorate } from 'tslib';
import { Location as Location$1, LocationStrategy, PlatformLocation } from '@angular/common';
import { ɵɵdefineInjectable, ɵɵinject, Injectable } from '@angular/core';
import { applyPatchesForLocationChangeEvent } from '@egovsolutions/locationchange-event';
import { fromEvent, concat, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
let Location = class Location extends Location$1 {
    constructor(
    // Dependencies
    locationStrategy, platformLocation) {
        super(locationStrategy, platformLocation);
        this.urlChange$ = fromEvent(window, 'locationchange').pipe(map(e => this.normalize(window.location.pathname)));
        this.url$ = concat(of(this.normalize(window.location.pathname)), this.urlChange$).pipe(shareReplay(1));
        this.hashChange$ = fromEvent(window, 'locationchange').pipe(map(e => this.normalize(window.location.hash)));
        this.hash$ = concat(of(this.normalize(window.location.hash)), this.hashChange$).pipe(shareReplay(1));
        applyPatchesForLocationChangeEvent();
    }
};
Location.ɵfac = function Location_Factory(t) { return new (t || Location)(ɵngcc0.ɵɵinject(ɵngcc1.LocationStrategy), ɵngcc0.ɵɵinject(ɵngcc1.PlatformLocation)); };
Location.ctorParameters = () => [
    { type: LocationStrategy },
    { type: PlatformLocation }
];
Location.ɵprov = ɵɵdefineInjectable({ factory: function Location_Factory() { return new Location(ɵɵinject(LocationStrategy), ɵɵinject(PlatformLocation)); }, token: Location, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Location, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.LocationStrategy }, { type: ɵngcc1.PlatformLocation }]; }, null); })();

/*
 * Public API Surface of angular-location
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Location };

